export default __webpack_public_path__ + "static/media/noimg.91daae49.jpeg";